exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-total-box p[data-v-4578a2e1]{font-size:1.6rem;margin-top:.5rem;font-weight:700}.billing-cards .card.card--basic[data-v-4578a2e1]{margin-top:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4578a2e1","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/accounts-receivable/billings/ArViewBilling.vue
// module id = Asbs
// module chunks = 0 1